import vueProductSvc from '../../services/vueProductSvc';

const state = {
  product: {},
  cmsSettings: {},
  attachableProdIds: [],
  tones: {
    'G': 'gold',
    'M': 'mahogany',
    'C': 'copper',
    'R': 'red',
    'A': 'ash'
  },
  toneMap: {
    'gold': 'Golden',
    'mahogany': 'Auburn',
    'copper': 'Copper',
    'red': 'Red',
    'ash': 'Smoky'
  }
};

const getters = {};

const actions = {
  getProductByUrlKey({ commit }, urlKey) {
    return new Promise((resolve, reject) => {
      vueProductSvc.getProductByUrlKey({ urlKey }).then(res => {
        commit('setProduct', res.data);

        if (!res.data.id) {
          return reject();
        }

        resolve();
      }).catch(reject);
    });
  },

  openPlaygroundModal({ dispatch }, params) {
    var modalParams = {
      ...params,
      component: './PDP/ColorKitPdp/PdpPlaygroundModal',
      theme: 'try-it-on-modal'
    };
    dispatch('modal/showModal', modalParams, { root: true });
  },

  openPurchasePanelModal({ dispatch }, returnFocusRef) {
    dispatch('modal/showModal', { component: './PDP/PurchasePanel/PurchasePanel', theme: 'full-screen', returnFocusElement: returnFocusRef }, { root: true });
  },

  openProductIngredientsModal({ dispatch }, params) {
    const modalParams = {
      ...params,
      component: './PDP/ProductIngredients/ProductIngredientsDetails',
    };
    dispatch('modal/showModal', modalParams, { root: true });
  },

};

const mutations = {
  setProduct(state, val) {
    state.product = val || {};
  },

  setCmsSettings(state, val) {
    state.cmsSettings = val;
  },

  setAttachableProdId(state, id) {
    if (!id || typeof +id != "number") {
      return console.error('setAttachableProdId accepts only numbers');
    }

    id = +id;
    let arr = state.attachableProdIds;

    if (!arr.includes(id)) {
      state.attachableProdIds.push(id);
    }
  },

  clearAttachableProdIds(state) {
    state.attachableProdIds = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
